import { NotificationsCatalogData } from '@repo/core'
import { generateCatalogSlice } from '../generators'

export const {
  actions: commonNotificationsCatalogActions,
  reducer: commonNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'common',
  namespace: 'notifications',
})

export const {
  actions: accountsNotificationsCatalogActions,
  reducer: accountsNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'accounts',
  namespace: 'notifications',
})

export const {
  actions: positionNotificationsCatalogActions,
  reducer: positionNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'position',
  namespace: 'notifications',
})

export const {
  actions: toolsNotificationsCatalogActions,
  reducer: toolsNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'tools',
  namespace: 'notifications',
})
export const {
  actions: userNotificationsCatalogActions,
  reducer: userNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'user',
  namespace: 'notifications',
})
export const {
  actions: mailboxNotificationsCatalogActions,
  reducer: mailboxNotificationsCatalogReducers,
} = generateCatalogSlice<NotificationsCatalogData>({
  domain: 'mailbox',
  namespace: 'notifications',
})
